<template>
  <v-container class="px-0 py-0">
    <!-- <v-row>
      <v-col
        cols="12"
        class="py-0"
      >
        <import-summary
          @stepTourSummaryReleased="$emit('stepTourSummaryReleased')"
          :contadores="contadores"
          :arquivos="entidades"
        />
      </v-col>
    </v-row> -->
    <v-row v-if="tabItens.length > 5">
      <v-col
        cols="12"
        class="pb-0 mb-n3"
      >
        <v-text-field
          v-model="filtroEntidades"
          append-icon="mdi-magnify"
          label="Buscar Entidades"
          hide-details
          single-line
        />
      </v-col>
    </v-row>
    <v-row v-if="filteredItens.length">
      <v-col
        cols="5"
        sm="3"
        class="pt-2 pb-0"
        id="menu-esquerdo-entidades-ib"
      >
        <v-card
          class="mt-4 mb-0 pb-0"
          style="height: 93% !important"
          elevation="0"
          outlined
        >
          <v-list
            flat
            class="overflow-y-auto pb-0"
            max-height="120vh"
          >
            <v-list-item-group
              v-model="selectedItem"
              color="primary"
              mandatory
            >
              <v-list-item
                v-for="(item, i) in filteredItens"
                :key="i"
                style="min-height: 38px !important; max-height: 38px !important"
              >
                <v-list-item-icon class="my-2">
                  <v-icon>{{
                    selectedItem == i ? 'mdi-folder-open' : 'mdi-folder'
                  }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    v-text="`${item}`"
                  />
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
      <v-col
        cols="7"
        sm="9"
        class="pb-0"
        v-if="selectedItemListGroup"
      >
        <v-col cols="12">
          <tabela-contadores
            :contadores="contadores[selectedItemListGroup]"
            :versao="versao"
            :tipo="selectedItemListGroup"
          />
        </v-col>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  components: {
    ImportSummary: () => import('@/components/administracao/importacoes-indger/ImportSummary'),
    TabelaContadores: () => import('@/components/administracao/importacoes-indger/TabelaContadores')
  },

  props: {
    entidades: {
      type: Array,
      required: true
    },
    contadores: {
      type: Object,
      required: true
    },
    versao: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    filtroEntidades: '',
    tabItens: [],
    selectedItem: 0
  }),

  mounted() {
    this.tabItens = this.entidades;
  },

  methods: {},

  computed: {
    filteredItens() {
      return this.tabItens.filter((item) =>
        item.toLowerCase().includes(this.filtroEntidades.toLowerCase())
      );
    },

    selectedItemListGroup() {
      return this.filteredItens.length
        ? this.filteredItens[this.selectedItem]
        : '';
    }
  }
};
</script>
